import { _ } from "../../core/polyglot/polyglot.js";
import externalDocument from "../shared/externalDocument.js";
import session from "../../core/session.js";
import userService from "../../core/services/userService.js";

/**
 *    `logoutDocument` is the document managing the logout process.
 *    It simply displays information since all the logic is
 *    managed by the server.
 *
 *    GET: /External/Authenticate/Logout
 */

/**
 * Todo: Add JSDoc comment
 */
function logoutDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = externalDocument(spec, my);

	that.title = _("Logged out");

	that.logout = function () {
		userService.logout(() => {
			if (!shouldRedirectToAgencyOnLogout()) {
				return;
			}
			window.location = getLogoutUrl();
		});

		that.update();
	};

	my.renderContentOn = function (html) {
		if (shouldRedirectToAgencyOnLogout()) {
			return;
		}

		html.div({ id: "document-title" }, html.h1(that.title));

		html.div(
			{ class: "row" },
			html.div(
				{
					class: "col-lg-4 col-lg-offset-4 col-sm-6 col-sm-offset-3 text-center",
				},
				html.p(
					{ class: "lead" },
					_("Thank you for the visit - You are now logged out."),
				),
				html.p(
					{ class: "lead" },
					html.a({ href: my.linkTo("login", {}) }, _("Login again?")),
					html.br(),
					html.a(
						{ href: getLogoutUrl() },
						_("Go to {agency}", { agency: getAgencyName() }),
					),
				),
			),
		);
	};

	function shouldRedirectToAgencyOnLogout() {
		const agency = session.getAgency();
		return agency && agency.shouldRedirectToAgencyOnLogout;
	}

	function getLogoutUrl() {
		return decodeURI(
			getHostingApplicationUrl() ||
				getCurrentAgencyHomepage() ||
				getCurrentCountryHomepage() ||
				"https://www.foretagsplatsen.se",
		);
	}

	function getHostingApplicationUrl() {
		const cookie = document.cookie.split("; ");
		for (const element of cookie) {
			const crumb = element.split("=");
			if (crumb[0] === "HostingApplicationUrl") {
				return crumb[1];
			}
		}
		return undefined;
	}

	function getCurrentAgencyHomepage() {
		const agency = session.getAgency();
		return agency && agency.homepage;
	}

	function getCurrentCountryHomepage() {
		const country = session.getCountry();
		return country && country?.supportInfo.webpage;
	}

	function getAgencyName() {
		const agency = session.getAgency();
		return (agency && agency.homepage && agency.name) || "finsit";
	}

	return that;
}

export default logoutDocument;
